import { Dialog, Transition, TransitionChild } from '@headlessui/react'
import { ReactNode } from 'react'

type ModalProps = {
  show: boolean
  onClose: () => void
  children: ReactNode | (() => ReactNode)

  beforeEnter?: () => void
  afterEnter?: () => void
  beforeLeave?: () => void
  afterLeave?: () => void
}

function Modal({ show, onClose, children, ...props }: ModalProps) {
  return (
    <Transition show={show} {...props}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-0 scale-95"
              enterTo="opacity-100 translate-y-0 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 scale-100"
              leaveTo="opacity-0 translate-y-0 scale-95"
            >
              <Dialog.Panel className="relative my-8 w-full max-w-xl transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
                {typeof children === 'function' ? children() : children}
              </Dialog.Panel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

Modal.Title = Dialog.Title

export default Modal
